// Check if the user has the required permissions
const hasPermission = (userPermissions, permissionNo) => {
  // If no permission is required, allow access
  if (!permissionNo) return true;
  return userPermissions[permissionNo] === true;
};

// A parent (has `children`) is shown ONLY when at least one child survives
// filtering — always with the FILTERED children. This prevents an always-true
// parent code (e.g. v500/v913) from leaking its whole unfiltered child list when
// the user has none of the child permissions. Leaf items gate on their own code.
export const filterMenusByPermissions = (menus, userPermissions) =>
  menus.reduce((acc, menu) => {
    if (menu.children) {
      const allowedSubmenus = filterMenusByPermissions(menu.children, userPermissions);
      if (allowedSubmenus.length > 0) acc.push({ ...menu, children: allowedSubmenus });
      return acc;
    }
    if (hasPermission(userPermissions, menu.permissionNo)) acc.push(menu);
    return acc;
  }, []);

export const truncateFilename = (name, maxLength = 20) => {
  if (name.length <= maxLength) return name;
  const extension = name.split('.').pop();
  const baseName = name.slice(0, maxLength - extension.length - 3);
  return `${baseName}...${extension}`;
};

export const removeHtmlString = (content) => {
  if (!content) return false; 

  const textOnly = content.replace(/<[^>]*>/g, '').trim();
  return textOnly.length > 0;
}